// eslint-disable-next-line
import React, { FC, useEffect } from 'react';

import { FieldProps } from 'formik';
import { Select } from 'components/forms';
import { TextFieldProps } from 'formik-material-ui';
import dictionary from 'utils/dictionary';
import { PhoneCompanies } from './phone-company.model';
import { useGetPhoneCompanies } from './hooks';

export type PhoneCompanySelectorProps = {
  isClaro?: boolean;
};

const PhoneCompanySelector: FC<
  PhoneCompanySelectorProps & FieldProps & Partial<TextFieldProps>
> = ({ isClaro = false, ...props }) => {
  const { form, field } = props;
  const { setFieldValue } = form;

  const { data: companies, isLoading, error, refetch } = useGetPhoneCompanies();

  useEffect(() => {
    if (isClaro) {
      setFieldValue(field.name, PhoneCompanies.Claro);
    } else {
      setFieldValue(
        field.name,
        PhoneCompanies[field.value] || PhoneCompanies.SinInformacion
      );
    }
  }, [field.name, field.value, isClaro, setFieldValue]);

  return (
    <Select
      fullWidth
      label={dictionary.clientForm_label_phoneCompany}
      items={companies}
      bindLabel="name"
      bindValue="name"
      isLoading={isLoading}
      error={error}
      onRefresh={refetch}
      InputProps={
        isClaro
          ? {
              readOnly: true,
            }
          : undefined
      }
      {...props}
    />
  );
};

export default PhoneCompanySelector;
